import { AmbientConversation } from "./ambientConversation.type";
import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";

/**
 * Create a new ambient conversation
 */
export async function createAmbientConversation(): Promise<AmbientConversation> {
  try {
    const slug = ApiEndpoints.ambientConversation;

    const options = await setHeaderOptions({
      method: "POST",
      body: {},
    });

    const response = await fetchData<AmbientConversation>(slug, options);

    return response;
  } catch (error) {
    console.error("Error creating ambient conversation:", error);
    throw error;
  }
}

/**
 * Get ambient conversations for a user
 */
export async function getAmbientConversations(): Promise<
  AmbientConversation[]
> {
  try {
    const slug = ApiEndpoints.ambientConversation;

    const options = await setHeaderOptions({
      method: "GET",
    });

    const response = await fetchData<AmbientConversation[]>(slug, options);
    return response;
  } catch (error) {
    console.error("Error getting ambient conversations:", error);
    throw error;
  }
}

/**
 * Get a specific ambient conversation by ID
 */
export async function getAmbientConversation(
  conversationId: string
): Promise<AmbientConversation> {
  try {
    const slug = `${ApiEndpoints.ambientConversation}/${conversationId}`;

    const options = await setHeaderOptions({
      method: "GET",
    });

    const response = await fetchData<AmbientConversation>(slug, options);

    return response;
  } catch (error) {
    console.error("Error getting ambient conversation:", error);
    throw error;
  }
}

export async function getConversationAnalysis(
  convoId: string
): Promise<AmbientConversation> {
  const slug = `${ApiEndpoints.ambientConversation}/${convoId}/analysis`;
  const options = await setHeaderOptions({ method: "GET" });
  const response = await fetchData<AmbientConversation>(slug, options);
  return response;
}

/**
 * Share an ambient conversation with a contact
 */
export async function shareAmbientConversation({
  conversationId,
  contactId,
}: {
  conversationId: string;
  contactId: string;
}): Promise<string> {
  try {
    const slug = `${ApiEndpoints.ambientConversation}/${conversationId}/share`;

    const options = await setHeaderOptions({
      method: "POST",
      body: { contactId },
    });

    const response = await fetchData<string>(slug, options);
    return response;
  } catch (error) {
    console.error("Error sharing ambient conversation:", error);
    throw error;
  }
}

/**
 * Update an ambient conversation
 */
export async function updateAmbientConversation(
  convoId: string
): Promise<AmbientConversation> {
  try {
    const slug = `${ApiEndpoints.ambientConversation}/${convoId}`;

    const options = await setHeaderOptions({
      method: "PUT",
    });

    const response = await fetchData<AmbientConversation>(slug, options);

    return response;
  } catch (error) {
    console.error("Error updating ambient conversation:", error);
    throw error;
  }
}

export async function completeAmbientConversation(
  convoId: string
): Promise<AmbientConversation> {
  try {
    const slug = `${ApiEndpoints.ambientConversation}/complete/${convoId}`;

    const options = await setHeaderOptions({
      method: "PUT",
    });

    const response = await fetchData<AmbientConversation>(slug, options);

    return response;
  } catch (error) {
    console.error("Error updating ambient conversation:", error);
    throw error;
  }
}

/**
 * Delete an ambient conversation
 */
export async function deleteAmbientConversation(
  conversation_id: string
): Promise<void> {
  try {
    const slug = `/ambient-conversations/${conversation_id}`;

    const options = await setHeaderOptions({
      method: "DELETE",
    });
    await fetchData<void>(slug, options);
  } catch (error) {
    console.error("Error deleting ambient conversation:", error);
    throw error;
  }
}
